import { render } from "./TwitterIcon.vue?vue&type=template&id=3deb0f34&scoped=true"
import script from "./TwitterIcon.vue?vue&type=script&lang=js"
export * from "./TwitterIcon.vue?vue&type=script&lang=js"

import "./TwitterIcon.vue?vue&type=style&index=0&id=3deb0f34&scoped=true&lang=css"

import exportComponent from "/Users/muftaua/Documents/dev/CCD-Stuff/web-ccd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3deb0f34"]])

export default __exports__